
/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import {throwError as observableThrowError,  Observable } from 'rxjs';
import { BaseApi } from './BaseApi';
import { ImportSurveyData } from '../../../lib/wwg.classes';

export enum SurveyActions {
  Recalculate = 'recalculate',
  Regenerate = 'regenerate',
  UtrvSetFragment = 'utrv_fragment',
}

interface ActionBody {
  _id: string;
  action: SurveyActions;
  [key: string]: any;
}

export class SurveyApi extends BaseApi {
  endPoint: string = '/api/admin/surveys';

  public executeAction(body: ActionBody): Observable<any> {
    if (!body._id) {
      throw observableThrowError('Cannot update document because no _id was supplied');
    }

    if (!body.action) {
      throw observableThrowError('Cannot update document because action was not supplied');
    }
    const _routeParams: any = {
      id: body._id
    };

    return this._put(this.endPoint + '/:id/action', _routeParams, body);
  }

  hardDelete(id: string, confirm: any) {
    const _routeParams = { id, confirm };
    return this._delete(this.endPoint + '/:id/delete?confirm=:confirm', _routeParams);
  }

  import(body: { survey: ImportSurveyData, options: Record<string, unknown> }): Observable<any> {
    return this.post(this.endPoint + '/import', {}, body);
  }
  importHistorical(formData: FormData) {
    return this.post(this.endPoint + '/importsgx', {}, formData);
  }
}
